import * as echarts from "echarts";
import { useEffect, useRef } from "react";
import { defaultColor } from "./util";

const EchartLine: React.FC<{
  xAxisData: string[];
  lineData: number[];
  barData: number[];
  legendData: string[];
}> = ({ xAxisData, lineData, barData, legendData }) => {
  const myRef = useRef<any>();
  useEffect(() => {
    const myChart = echarts.init(myRef.current, undefined, {
      renderer: "canvas",
      useDirtyRect: false,
    });
    const option = {
      //   backgroundColor: "#05224d",
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
        },
      },
      tooltip1: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        backgroundColor: "rgba(9, 24, 48, 0.8)",
        borderColor: "rgba(75, 253, 238, 0.4)",
        textStyle: {
          color: "#FFF",
        },
        borderWidth: 1,
        formatter: function (params: any) {
          let str = "";
          for (let i = 0; i < params.length; i++) {
            if (i == 0) {
              str += `${params[i].name}<br/>${params[i].seriesName.slice(
                0,
                params[i].seriesName.indexOf("(")
              )}<br/><span>${params[0].data}</span>%<br/>`;
              continue;
            }
            str += `${params[i].seriesName.slice(
              0,
              params[i].seriesName.indexOf("(")
            )}<br/><span>${params[i].data}</span>个<br/>`;
          }
          return str;
        },
      },
      //   grid: {
      //     top: "8%",
      //     left: "1%",
      //     right: "1%",
      //     bottom: "8%",
      //     containLabel: true,
      //   },
      legend: {
        itemGap: 50,
        data: legendData, // ["累计", "月度"],
        textStyle: {
          color: "#f9f9f9",
          borderColor: "#fff",
        },
      },
      xAxis: [
        {
          type: "category",
          boundaryGap: true,
          axisLine: {
            //坐标轴轴线相关设置。数学上的x轴
            show: true,
            lineStyle: {
              color: "#f9f9f9",
            },
          },
          axisLabel: {
            //坐标轴刻度标签的相关设置
            textStyle: {
              color: "#d1e6eb",
              margin: 15,
            },
          },
          axisTick: {
            show: false,
          },
          data: xAxisData,
          // data: ["1月", "2月", "3月", "4月", "5月", "6月", "7月"],
        },
      ],
      yAxis: [
        {
          type: "value",
          min: 0,
          // max: 140,
          splitNumber: 7,
          splitLine: {
            show: true,
            lineStyle: {
              color: "#0a3256",
            },
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            margin: 20,
            textStyle: {
              color: "#d1e6eb",
            },
          },
          axisTick: {
            show: false,
          },
        },
        {
          type: "value",
          //   axisLabel: {
          //     formatter: '{value} W'
          //   },
          min: 0,
          // max: 140,
          splitNumber: 7,
          splitLine: {
            show: true,
            lineStyle: {
              color: "#0a3256",
            },
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            margin: -6,
            textStyle: {
              color: "#fff",
            },
            formatter: "{value}亿元",
          },
          axisTick: {
            show: false,
          },
        },
      ],
      series: [
        {
          name: legendData[0],
          yAxisIndex: 1,
          animationDuration: 5000,
          smooth: true, //平滑曲线显示
          //   showAllSymbol: true, //显示所有图形。
          //   symbol: "circle", //标记的图形为实心圆
          type: "line",
          // smooth: true, //是否平滑曲线显示
          // 			symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
          // showAllSymbol: true,
          symbol: "emptyCircle",
          symbolSize: 6,
          lineStyle: {
            normal: {
              color: "#28ffb3", // 线条颜色
            },
            borderColor: "#f0f",
          },
          label: {
            show: false,
            position: "top",
            textStyle: {
              color: "#fff",
            },
          },
          itemStyle: {
            normal: {
              color: "#28ffb3",
            },
          },
          tooltip: {
            show: true,
          },
          areaStyle: {
            //区域填充样式
            normal: {
              //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "#3d88b3",
                  },
                  {
                    offset: 1,
                    // color: "rgba(0,0,0, 0)",
                    color: "rgba(29, 49, 126, .7)",
                  },
                ],
                false
              ),
              shadowColor: "rgba(53,142,215, 0.9)", //阴影颜色
              shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
            },
          },
          data: lineData,
          //   data: [393, 438, 485, 631, 689, 824, 987],
        },
        {
          name: legendData[1],
          animationDuration: 8000,
          yAxisIndex: 0,
          type: "bar",
          barWidth: 10,
          tooltip: {
            show: true,
          },
          label: {
            show: false,
            position: "top",
            textStyle: {
              color: "#fff",
            },
          },
          itemStyle: {
            normal: {
              barBorderRadius: 5,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#0d3a7e",
                },
                {
                  offset: 1,
                  color: "#43eec6",
                },
              ]),
              // color: function (params: any) {
              //   return (
              //     defaultColor[params.dataIndex] ||
              //     defaultColor[defaultColor.length - 1]
              //   );
              // },
            },
          },
          data: barData,
          //   data: [200, 382, 102, 267, 186, 315, 316],
        },
      ],
    };

    if (option && typeof option === "object") {
      myChart.setOption(option);
    }
    const interValId = setInterval(() => {
      myChart.setOption(option);
    }, 200);
    return () => {
      clearInterval(interValId);
    };
  }, [lineData, barData]);
  return (
    <div
      ref={myRef}
      style={{
        height: "280px",
      }}
    ></div>
  );
};
export default EchartLine;
